export enum InvoiceMode {
    Draft = 'draft',
    Active = 'active',
}
